"use strict";
if (!window._hmt_private) {
    window._hmt = window._hmt || [];
    (function () {
        var hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?b97569d26a525941d8d163729d284198';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
    })();
}
